import "./App.css";
import LandingPage from "./Component/LandingPage";

import VideoPage from './Component/VideoPage';
import { Route, Switch } from "react-router-dom";

export const config = {
  endpoint:`https://xflix-nodesachin.herokuapp.com/v1`
};
function App() {
  return (
    <div style={{ backgroundColor: "#181818", minHeight: "100vh" }}>
     
     
      <Switch>
      <Route  path="/" exact  >
        <LandingPage/>
      </Route>
      <Route path="/Video/:id">
        <VideoPage/>
      </Route>
      </Switch>
     
    </div>
  );
}

export default App;
